import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const  getAllMaterialList = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getAllMaterialList - error", error)
        return handleApiError(error)
    }
}

export const  searchAllMaterialList = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/search`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("searchAllMaterialList - error", error)
        return handleApiError(error)
    }
}

export const  downloadMaterialMasterData = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/download`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("downloadMaterialMasterData - error", error)
        return handleApiError(error)
    }
}

export const  getMaterialItemByMaterialId = async (materialId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/material-master/${materialId}`);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialItemByMaterialId - error", error)
        return handleApiError(error)
    }
}

export const  getMaterialItem = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/materialItem`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialItem - error", error)
        return handleApiError(error)
    }
}

export const insertMaterialMaster = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/create`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("insertMaterialMaster error:", error)
        return handleApiError(error)
    }
}

export const inserVMIMaterialMaster = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/vmi/create`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("inserVMIMaterialMaster error:", error)
        return handleApiError(error)
    }
}

export const updateMaterialMasterByMaterialId = async (data) => {
    try {
        const { materialId } = data
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/${materialId}`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("updateMaterialMasterByMaterialId error:", error)
        return handleApiError(error)
    }
}

export const  getMaterialMasterAndTempMaterialIds = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/materialMasterAndTempMaterialIds`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialMasterAndTempMaterialIds - error", error)
        return handleApiError(error)
    }
}

export const  getMaterialMasterAndTempMaterialIdsById = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/materialMasterAndTempMaterialIdsById`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialMasterAndTempMaterialIdsById - error", error)
        return handleApiError(error)
    }
}

export const  getMaterialMasterBySearchText = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/materialMasterBySearchText`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialMasterBySearchText - error", error)
        return handleApiError(error)
    }
}

export const getMaterialMasterByCompanyERPCode = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/materialMasterByERPCode`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialMasterBySearchText - error", error)
        return handleApiError(error)
    }
}

export const getVMIMaterialsByCompanyERPCode = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/material-master/vmi/materials-by-erpcode`, data);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getVMIMaterialsByCompanyERPCode - error", error)
        return handleApiError(error)
    }
}

export const getMaterialMasterAndTempMaterialIdsByBrandId = async (brandId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/material-master/brand/${brandId}`)
        const result = await res.data
        return result
    } catch (error) {
        console.log("getMaterialMasterAndTempMaterialIdsByBrandId - error", error)
        return handleApiError(error)
    }
}

export const getTopMatchMaterialSpecificationUsingParser = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master/top-matches-specs`, data)
        return await response.data;
    } catch (error) {
        console.log("getTopMatchMaterialSpecificationUsingParser - error", error)
        return handleApiError(error)
    }
}